import { createSelector } from 'reselect';

// ESS change starts here
const draggableLayout = () => state => state.get('draggableLayout');

const getSidebarWidth = () =>
  createSelector(draggableLayout(), state => state.get('sideBarWidth'));

export { getSidebarWidth };
